import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbDownSelectedDisabled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "black",
			fillOpacity: .38
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00879 21V9.01807H9.99121V21H8.00879Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1011 25.4588C17.2539 26.7066 19.3006 25.5373 18.8112 23.9106L17.9944 21H21.6805C22.4294 21 23.1255 20.6142 23.5225 19.9791C24.0316 19.1644 24.1324 18.1592 23.7951 17.2597L21.9678 11.6162C21.3819 10.0537 19.8893 9.01807 18.2199 9.01807H14.4081C13.0805 9.01807 12.0068 10.0944 12.0068 11.4205V19.8859C12.0068 20.2888 12.1587 20.6768 12.432 20.9727L16.1011 25.4588Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgThumbDownSelectedDisabled);
export { ForwardRef as ReactComponent };
